const monthNames = [
    'januarja',
    'februarja',
    'marca',
    'aprila',
    'maja',
    'junija',
    'julija',
    'avgusta',
    'septembra',
    'oktobra',
    'novembra',
    'decembra',
]

const dayNames = ['nedelje', 'ponedeljka', 'torka', 'srede', 'četrtka', 'petka', 'sobote']

export function isValidEmail(email: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailPattern.test(email)
}

export async function preloadImages(imageUrls: string[]): Promise<void[]> {
    const promises: Promise<void>[] = []

    imageUrls.forEach(url => {
        const image = new Image()
        image.src = url
        promises.push(
            new Promise(resolve => {
                image.onload = () => resolve()
            }),
        )
    })

    return Promise.all(promises)
}

export function htmlElementsUntil(selectors: string[], fromElement: Element): HTMLElement[] {
    const betweenElements: HTMLElement[] = []
    let next = fromElement.nextElementSibling
    while (next && !selectors.some(selector => next!.matches(selector))) {
        betweenElements.push(next as HTMLElement)
        next = next.nextElementSibling
    }
    return betweenElements
}

export function preventBodyScroll(additionalStyles?: string) {
    const scrollbarWidth = Math.abs(window.innerWidth - document.documentElement.clientWidth)

    const styleTag = document.createElement('style')
    styleTag.appendChild(
        document.createTextNode(
            `body { overflow: hidden !important; padding-right: ${scrollbarWidth}px !important; } ${
                additionalStyles || ''
            }`,
        ),
    )
    document.head.appendChild(styleTag)
    return styleTag
}

export function isDevMode() {
    return process.env.NODE_ENV === 'development'
}

export function daysBetween(date1: Date, date2: Date): number {
    const diffInMs = date2.getTime() - date1.getTime()
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24))
    return diffInDays
}

export function formatDate(date: Date): string {
    return date.toLocaleDateString('sl-SI').replaceAll(' ', '')
}

export function formatDays(days: number): string {
    return days === 1 ? '1 dan' : `${days} dni`
}

export function strToDate(dateStr: string | undefined): Date {
    if (!dateStr) return new Date()
    const [day, month, year] = dateStr.split('.').map(Number)
    return new Date(year, month - 1, day)
}

export function dayAndMonth(date: Date): string {
    return `${date.getDate()}. ${date.getMonth() + 1}.`
}

export function slovenianDayMonth(date: Date): string {
    return `${date.getDate()}. ${monthNames[date.getMonth()]}.`
}

export function slovenianDayOfWeek(date: Date): string {
    return dayNames[date.getDay()]
}

export function radToDegrees(radians: number): number {
    return (radians * 180) / Math.PI
}

export function isNear(n: number, aim: number, tolerance: number): boolean {
    return n >= aim - tolerance && n <= aim + tolerance
}

export function isBotUserAgent(): boolean {
    return /bot|crawler|spider|curl|wget|slurp|fetch|scan|httrack|heritrix|mediapartners-google|adsbot-google|feedfetcher-google|w3c_validator|ia_archiver/i.test(
        navigator.userAgent,
    )
}
